<template>
<div class="large-container">
	<Row>
		<Col span="12">
			<h3>{{info.companyName}}</h3>
		</Col>
		<Col span="12" class="right">
			<Button type="primary" @click="openSettleUrl" v-if="info.attachmentUrl">查看结算单</Button>
			<UploadFileImg 
				@on-success="uploadSuccess" 
				type="select" 
				:btn-text="info.status=='WAIT_DONE'?'上传结算单':'重新上传结算单'" 
				v-if="info.status=='WAIT_DONE'||info.status=='WAIT_CONFIRM'"/> 
			<Button type="success" @click="excel">导出名单</Button>
		</Col>
	</Row>
	<Form :label-width="120" class="info">
		<Row>
			<Col span="6">
				<FormItem label="操作人：">
					{{info.userName}}
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="状态：">
					{{info.statusName}}
				</FormItem>
			</Col>
		</Row>
	</Form>
	<div class="title">参加人员信息</div>
	<p class="totalM mt10">参保人员：{{info.userSize}}人，结算保费合计：{{info.premiumAmount}}元</p>
	<Table :columns="columns" :data="list" border ></Table>
</div>
</template>
<script>
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{UploadFileImg},
	data () {
		return {
			info:{},
			id:this.$route.params.id,
			list:[],
			columns:[
				{title: '员工号',key: 'empNo',width:160},
				{title: '手机号',key: 'phone',width:130},
				{title: '姓名',key: 'name',width:120},
				{title: '性别',key: 'genderName',width:80},
				{title: '证件类型',key: 'idTypeName',width:95},
				{title: '证件号码',key: 'idNumber',width:190},
				{title: '出生日期',key: 'birthday',width:120},
				{title: '社保',key: 'hasSocialSecurityShow',width:80},
				{title: '职业',key: 'jobType',width:120},
				{title: '参保公司',key: 'companyName',minWidth:200},
				{title: 'SAP入职时间',key: 'entryDate',width:160},
				{title: '起保日期',key: 'effectiveDateStart',width:180},
				{title: '终保日期',key: 'effectiveDateEnd',width:180},
				{title: '保障方案',key: 'insurancePlan',width:120},
				{title: '保费（元）',key: 'premiumAmount',width:110},
				{title: '保障状态',key: 'insuranceStatusName',width:130},
			],
			productCode:'JIN_KONG'
		}
	},
	created () {
		this.getInfo();
	},
	methods:{
		/*获取详情*/
		getInfo () {
			this.$axios.post('/guarantee/queryStatementsDetail',{
				statementsId:this.id
			}).then(res=>{
				this.info=res
				this.list=res.details
			});
		},
		excel() {
			this.exportToExcel('/guarantee/exportEndBillDetail',{
				statementsId:this.id,
				productCode:this.productCode,
			});
		},
		openSettleUrl(){
			window.open(this.info.attachmentUrl)
		},
		uploadSuccess(val){
			this.$axios.post('/guarantee/uploadStatements.json',{
				ids:[this.id],
				attachmentUrl:val.url
			}).then(res=>{
				this.getInfo();
				this.toast('上传成功')
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/jinkong/detail/SettleDetails.vue